import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getLoginDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  mobileLoginPage: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Welcome Page Image",
      fieldValue: "field_welcome_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_welcome_page_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Welcome Page Image",
      placeholder: "Upload Image",
      validation: { required: "Welcome Page Image is required" },
    },
    {
      fieldName: "Welcome Text (EN)",
      fieldValue: "field_welcome_text",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_text",
      formType: "input",
      label: "Welcome Text (EN)",
      placeholder: "Enter Welcome Text (EN)",
      validation: { required: "Welcome Text (EN) is required" },
    },
    {
      fieldName: "Welcome Text (MS)",
      fieldValue: "field_welcome_ms",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_ms",
      formType: "input",
      label: "Welcome Text (MS)",
      placeholder: "Enter Welcome Text (MS)",
      // validation: { required: "Welcome Text (MS) is required" },
    },
    {
      fieldName: "Welcome Text (ZH)",
      fieldValue: "field_welcome_zh",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_zh",
      formType: "input",
      label: "Welcome Text (ZH)",
      placeholder: "Enter Welcome Text (ZH)",
      // validation: { required: "Welcome Text (ZH) is required" },
    },
    {
      fieldName: "Welcome Procurement Text (EN)",
      fieldValue: "field_welcome_procurement_text",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_procurement_text",
      formType: "input",
      label: "Welcome Procurement Text (EN)",
      placeholder: "Enter Procurement Text (EN)",
      validation: { required: "Procurement Text (EN) is required" },
    },
    {
      fieldName: "Welcome Procurement Text (MS)",
      fieldValue: "field_welcome_procurement_ms",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_procurement_ms",
      formType: "input",
      label: "Welcome Procurement Text (MS)",
      placeholder: "Enter Procurement Text (MS)",
      // validation: { required: "Procurement Text (MS) is required" },
    },
    {
      fieldName: "Welcome Procurement Text (ZH)",
      fieldValue: "field_welcome_procurement_zh",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_procurement_zh",
      formType: "input",
      label: "Welcome Procurement Text (ZH)",
      placeholder: "Enter Procurement Text (ZH)",
      // validation: { required: "Procurement Text (ZH) is required" },
    },
    {
      fieldName: "Welcome Guidelines Text (EN)",
      fieldValue: "field_welcome_guidelines_text",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_guidelines_text",
      formType: "input",
      label: "Welcome Guidelines Text (EN)",
      placeholder: "Enter Guidelines Text (EN)",
      validation: { required: "Guidelines Text (EN) is required" },
    },
    {
      fieldName: "Welcome Guidelines Text (MS)",
      fieldValue: "field_welcome_guidelines_ms",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_guidelines_ms",
      formType: "input",
      label: "Welcome Guidelines Text (MS)",
      placeholder: "Enter Guidelines Text (MS)",
      // validation: { required: "Guidelines Text (MS) is required" },
    },
    {
      fieldName: "Welcome Guidelines Text (ZH)",
      fieldValue: "field_welcome_guidelines_zh",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_guidelines_zh",
      formType: "input",
      label: "Welcome Guidelines Text (ZH)",
      placeholder: "Enter Guidelines Text Button (ZH)",
      // validation: { required: "Guidelines Text (ZH) is required" },
    },
    {
      fieldName: "Guest Login Button (EN)",
      fieldValue: "field_guest_login_text",
      className: "col-span-6",
      type: "text",
      name: "field_guest_login_text",
      formType: "input",
      label: "Guest Login Button (EN)",
      placeholder: "Enter Guest Login Button (EN)",
      validation: { required: "Guest Login Button (EN) is required" },
    },
    {
      fieldName: "Guest Login Button (MS)",
      fieldValue: "field_guest_login_text_malay",
      className: "col-span-6",
      type: "text",
      name: "field_guest_login_text_malay",
      formType: "input",
      label: "Guest Login Button (MS)",
      placeholder: "Enter Guest Login Button (MS)",
      // validation: { required: "Guest Login (MS) is required" },
    },
    {
      fieldName: "Guest Login Button (ZH)",
      fieldValue: "field_guest_login_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_guest_login_text_zh",
      formType: "input",
      label: "Guest Login Button (ZH)",
      placeholder: "Enter Guest Login Button (ZH)",
      // validation: { required: "Guest Login (ZH) is required" },
    },
    {
      fieldName: "Vendor Login Button (EN)",
      fieldValue: "field_vendor_login_text",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_login_text",
      formType: "input",
      label: "Vendor Login Button (EN)",
      placeholder: "Enter Vendor Login Button (EN)",
      validation: { required: "Vendor Login Button (EN) is required" },
    },
    {
      fieldName: "Vendor Login Button (MS)",
      fieldValue: "field_vendor_login_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_login_text_ms",
      formType: "input",
      label: "Vendor Login Button (MS)",
      placeholder: "Enter Vendor Login Button (MS)",
      // validation: { required: "Vendor Login (MS) is required" },
    },
    {
      fieldName: "Vendor Login Button (ZH)",
      fieldValue: "field_vendor_login_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_login_text_zh",
      formType: "input",
      label: "Vendor Login Button (ZH)",
      placeholder: "Enter Vendor Login Button (ZH)",
      // validation: { required: "Vendor Login (ZH) is required" },
    },
    {
      fieldName: "Staff Login Button (EN)",
      fieldValue: "field_staff_login_text",
      className: "col-span-6",
      type: "text",
      name: "field_staff_login_text",
      formType: "input",
      label: "Staff Login Button (EN)",
      placeholder: "Enter Staff Login Button (EN)",
      validation: { required: "Staff Login Button (EN) is required" },
    },
    {
      fieldName: "Staff Login Button (MS)",
      fieldValue: "field_staff_login_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_staff_login_text_ms",
      formType: "input",
      label: "Staff Login Button (MS)",
      placeholder: "Enter Staff Login Button (MS)",
      // validation: { required: "Staff Login (MS) is required" },
    },
    {
      fieldName: "Staff Login Button (ZH)",
      fieldValue: "field_staff_login_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_staff_login_text_zh",
      formType: "input",
      label: "Staff Login Button (ZH)",
      placeholder: "Enter Staff Login Button (ZH)",
      // validation: { required: "Staff Login (ZH) is required" },
    },
  ],
  mobileCalendarPage: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_calendar_header_text",
      className: "col-span-6",
      type: "text",
      name: "field_malay_calendar_header_text",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_calendar_header_t",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_calendar_header_t",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Welcome Page Image",
      fieldValue: "field_magp_image",
      className: "col-span-6",
      type: "image",
      name: "field_magp_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Welcome Page Image",
      placeholder: "Upload Image",
      validation: { required: "Welcome Page Image is required" },
    },
    {
      fieldName: "Welcome Text (EN)",
      fieldValue: "field_welcome_calendar_text",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_calendar_text",
      formType: "input",
      label: "Welcome Text (EN)",
      placeholder: "Enter Welcome Text (EN)",
      validation: { required: "Welcome Text (EN) is required" },
    },
    {
      fieldName: "Welcome Text (MS)",
      fieldValue: "field_malay_welcome_calendar_tex",
      className: "col-span-6",
      type: "text",
      name: "field_malay_welcome_calendar_tex",
      formType: "input",
      label: "Welcome Text (MS)",
      placeholder: "Enter Welcome Text (MS)",
      // validation: { required: "Welcome Text (MS) is required" },
    },
    {
      fieldName: "Welcome Text (ZH)",
      fieldValue: "field_mandarin_welcome_calendar",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_welcome_calendar",
      formType: "input",
      label: "Welcome Text (ZH)",
      placeholder: "Enter Welcome Text (ZH)",
      // validation: { required: "Welcome Text (ZH) is required" },
    },
    // {
    //   fieldName: "Welcome Description (EN)",
    //   fieldValue: "field_welcome_calendar_descripti",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_welcome_calendar_descripti",
    //   formType: "richText",
    //   label: "Welcome Description (EN)",
    //   placeholder: "Enter Welcome Description (EN)",
    //   validation: { required: "Welcome Description (EN) is required" },
    // },
    // {
    //   fieldName: "Welcome Description (MS)",
    //   fieldValue: "field_malay_welcome_calendar_des",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_malay_welcome_calendar_des",
    //   formType: "richText",
    //   label: "Welcome Description (MS)",
    //   placeholder: "Enter Welcome Description (MS)",
    //   // validation: { required: "Procurement Text (MS) is required" },
    // },
    // {
    //   fieldName: "Welcome Description (ZH)",
    //   fieldValue: "field_mandari_welco_calen_descri",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_mandari_welco_calen_descri",
    //   formType: "richText",
    //   label: "Welcome Description (ZH)",
    //   placeholder: "Enter Welcome Description (ZH)",
    //   // validation: { required: "Procurement Text (ZH) is required" },
    // },
    {
      fieldName: "Continue Text (EN)",
      fieldValue: "field_calendar_welcom_continue",
      className: "col-span-6",
      type: "text",
      name: "field_calendar_welcom_continue",
      formType: "input",
      label: "Continue Text (EN)",
      placeholder: "Enter Continue Text (EN)",
      validation: { required: "Continue Text (EN) is required" },
    },
    {
      fieldName: "Continue Text (MS)",
      fieldValue: "field_malay_continue_text",
      className: "col-span-6",
      type: "text",
      name: "field_malay_continue_text",
      formType: "input",
      label: "Continue Text (MS)",
      placeholder: "Enter Continue Text (MS)",
      // validation: { required: "Guidelines Text (MS) is required" },
    },
    {
      fieldName: "Continue Text (ZH)",
      fieldValue: "field_mandarin_continue_text",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_continue_text",
      formType: "input",
      label: "Continue Text (ZH)",
      placeholder: "Enter Continue Text (ZH)",
      // validation: { required: "Guidelines Text (ZH) is required" },
    },
  ],
  webLoginPage: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_web_login_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_web_login_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_web_login_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Title Color Code",
      fieldValue: "field_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_title_colour",
      formType: "color",
      label: "Title Color Code",
      placeholder: "Enter Title Color Code",
      validation: { required: "Title Color Code is required" },
    },
    {
      fieldName: "Sub Title (EN)",
      fieldValue: "field_web_login_page_subtitle_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_en",
      formType: "input",
      label: "Sub Title (EN)",
      placeholder: "Enter Sub Title (EN)",
      validation: { required: "Sub Title (EN) is required" },
    },
    {
      fieldName: "Sub Title (MS)",
      fieldValue: "field_web_login_page_subtitle_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_ms",
      formType: "input",
      label: "Sub Title (MS)",
      placeholder: "Enter Sub Title (MS)",
      // validation: { required: "Sub Title (MS) is required" },
    },
    {
      fieldName: "Sub Title (ZH)",
      fieldValue: "field_web_login_page_subtitle_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_zh",
      formType: "input",
      label: "Sub Title (ZH)",
      placeholder: "Enter Sub Title (ZH)",
      // validation: { required: "Sub Title (ZH) is required" },
    },
    {
      fieldName: "Sub Title Color Code",
      fieldValue: "field_sub_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_sub_title_colour",
      formType: "color",
      label: "Sub Title Color Code",
      placeholder: "Enter Sub Title Color Code",
      validation: { required: "Sub Title Color Code is required" },
    },
    {
      fieldName: "Link",
      fieldValue: "field_web_login_page_link",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_link",
      formType: "input",
      label: "Link",
      placeholder: "Enter Link",
      validation: { required: "Link is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_web_login_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_web_login_page_image",
      formType: "file",
      note: "Please upload an image in PNG, JPEG, or JPG format.",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: " Image is required" },
    },
  ],
  mainLoginPage: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_web_login_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Sub Title (EN)",
      fieldValue: "field_web_login_page_subtitle_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_en",
      formType: "input",
      label: "Sub Title (EN)",
      placeholder: "Enter Sub Title (EN)",
      validation: { required: "Sub Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_web_login_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Sub Title (MS)",
      fieldValue: "field_web_login_page_subtitle_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_ms",
      formType: "input",
      label: "Sub Title (MS)",
      placeholder: "Enter Sub Title (MS)",
      // validation: { required: "Sub Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_web_login_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Sub Title (ZH)",
      fieldValue: "field_web_login_page_subtitle_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_zh",
      formType: "input",
      label: "Sub Title (ZH)",
      placeholder: "Enter Sub Title (ZH)",
      // validation: { required: "Sub Title (ZH) is required" },
    },
    {
      fieldName: "Title Color Code",
      fieldValue: "field_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_title_colour",
      formType: "color",
      label: "Title Color Code",
      placeholder: "Enter Title Color Code",
      validation: { required: "Title Color Code is required" },
    },
    {
      fieldName: "Sub Title Color Code",
      fieldValue: "field_sub_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_sub_title_colour",
      formType: "color",
      label: "Sub Title Color Code",
      placeholder: "Enter Sub Title Color Code",
      validation: { required: "Sub Title Color Code is required" },
    },
    // {
    //   fieldName: "Link",
    //   fieldValue: "field_web_login_page_link",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_web_login_page_link",
    //   formType: "input",
    //   label: "Link",
    //   placeholder: "Enter Link",
    //   validation: { required: "Link is required" },
    // },
    {
      fieldName: "Image",
      fieldValue: "field_web_login_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_web_login_page_image",
      formType: "file",
      note: "Please upload an image in PNG, JPEG, or JPG format.",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: " Image is required" },
    },
  ],
  vendorLoginPage: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_web_login_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Sub Title (EN)",
      fieldValue: "field_web_login_page_subtitle_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_en",
      formType: "input",
      label: "Sub Title (EN)",
      placeholder: "Enter Sub Title (EN)",
      validation: { required: "Sub Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_web_login_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Sub Title (MS)",
      fieldValue: "field_web_login_page_subtitle_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_ms",
      formType: "input",
      label: "Sub Title (MS)",
      placeholder: "Enter Sub Title (MS)",
      // validation: { required: "Sub Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_web_login_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Sub Title (ZH)",
      fieldValue: "field_web_login_page_subtitle_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_zh",
      formType: "input",
      label: "Sub Title (ZH)",
      placeholder: "Enter Sub Title (ZH)",
      // validation: { required: "Sub Title (ZH) is required" },
    },
    {
      fieldName: "Title Color Code",
      fieldValue: "field_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_title_colour",
      formType: "color",
      label: "Title Color Code",
      placeholder: "Enter Title Color Code",
      validation: { required: "Title Color Code is required" },
    },
    {
      fieldName: "Sub Title Color Code",
      fieldValue: "field_sub_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_sub_title_colour",
      formType: "color",
      label: "Sub Title Color Code",
      placeholder: "Enter Sub Title Color Code",
      validation: { required: "Sub Title Color Code is required" },
    },
    // {
    //   fieldName: "Link",
    //   fieldValue: "field_web_login_page_link",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_web_login_page_link",
    //   formType: "input",
    //   label: "Link",
    //   placeholder: "Enter Link",
    //   validation: { required: "Link is required" },
    // },
    {
      fieldName: "Image",
      fieldValue: "field_web_login_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_web_login_page_image",
      formType: "file",
      note: "Please upload an image in PNG, JPEG, or JPG format.",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: " Image is required" },
    },
  ],
  forgotPassword: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_web_login_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Sub Title (EN)",
      fieldValue: "field_web_login_page_subtitle_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_en",
      formType: "input",
      label: "Sub Title (EN)",
      placeholder: "Enter Sub Title (EN)",
      validation: { required: "Sub Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_web_login_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Sub Title (MS)",
      fieldValue: "field_web_login_page_subtitle_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_ms",
      formType: "input",
      label: "Sub Title (MS)",
      placeholder: "Enter Sub Title (MS)",
      // validation: { required: "Sub Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_web_login_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Sub Title (ZH)",
      fieldValue: "field_web_login_page_subtitle_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_zh",
      formType: "input",
      label: "Sub Title (ZH)",
      placeholder: "Enter Sub Title (ZH)",
      // validation: { required: "Sub Title (ZH) is required" },
    },
    {
      fieldName: "Title Color Code",
      fieldValue: "field_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_title_colour",
      formType: "color",
      label: "Title Color Code",
      placeholder: "Enter Title Color Code",
      validation: { required: "Title Color Code is required" },
    },
    {
      fieldName: "Sub Title Color Code",
      fieldValue: "field_sub_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_sub_title_colour",
      formType: "color",
      label: "Sub Title Color Code",
      placeholder: "Enter Sub Title Color Code",
      validation: { required: "Sub Title Color Code is required" },
    },
    // {
    //   fieldName: "Link",
    //   fieldValue: "field_web_login_page_link",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_web_login_page_link",
    //   formType: "input",
    //   label: "Link",
    //   placeholder: "Enter Link",
    //   validation: { required: "Link is required" },
    // },
    {
      fieldName: "Image",
      fieldValue: "field_web_login_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_web_login_page_image",
      formType: "file",
      note: "Please upload an image in PNG, JPEG, or JPG format.",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: " Image is required" },
    },
  ],
  signUp: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_web_login_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Sub Title (EN)",
      fieldValue: "field_web_login_page_subtitle_en",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_en",
      formType: "input",
      label: "Sub Title (EN)",
      placeholder: "Enter Sub Title (EN)",
      validation: { required: "Sub Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_web_login_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Sub Title (MS)",
      fieldValue: "field_web_login_page_subtitle_ms",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_ms",
      formType: "input",
      label: "Sub Title (MS)",
      placeholder: "Enter Sub Title (MS)",
      // validation: { required: "Sub Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_web_login_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Sub Title (ZH)",
      fieldValue: "field_web_login_page_subtitle_zh",
      className: "col-span-6",
      type: "text",
      name: "field_web_login_page_subtitle_zh",
      formType: "input",
      label: "Sub Title (ZH)",
      placeholder: "Enter Sub Title (ZH)",
      // validation: { required: "Sub Title (ZH) is required" },
    },
    {
      fieldName: "Title Color Code",
      fieldValue: "field_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_title_colour",
      formType: "color",
      label: "Title Color Code",
      placeholder: "Enter Title Color Code",
      validation: { required: "Title Color Code is required" },
    },
    {
      fieldName: "Sub Title Color Code",
      fieldValue: "field_sub_title_colour",
      className: "col-span-6",
      type: "text",
      name: "field_sub_title_colour",
      formType: "color",
      label: "Sub Title Color Code",
      placeholder: "Enter Sub Title Color Code",
      validation: { required: "Sub Title Color Code is required" },
    },
    // {
    //   fieldName: "Link",
    //   fieldValue: "field_web_login_page_link",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_web_login_page_link",
    //   formType: "input",
    //   label: "Link",
    //   placeholder: "Enter Link",
    //   validation: { required: "Link is required" },
    // },
    {
      fieldName: "Image",
      fieldValue: "field_web_login_page_image",
      className: "col-span-6",
      type: "image",
      name: "field_web_login_page_image",
      formType: "file",
      note: "Please upload an image in PNG, JPEG, or JPG format.",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: " Image is required" },
    },
  ],
};
